import React from "react";
import { useRecoilValue } from 'recoil'

import { visitorAndSpendOptionsAtom, visitorAndSpendTypeAtom } from './atoms'

const baseStyle = {
	whiteSpace: "pre",
	fontFamily: "Roboto, Helvetica, Arial, sans-serif",
	fontSize: 14,
	letterSpacing: 0,
}

const subStyle = {
	...baseStyle,
	fontSize: 12,
}

const headlineStyle = {
	...baseStyle,
	fontWeight: 'bold',
}

export default function VisitorAndSpendLegend() {
	const visitorAndSpendOptions = useRecoilValue(visitorAndSpendOptionsAtom)
	const visitorAndSpendType = useRecoilValue(visitorAndSpendTypeAtom)

	const renderLegend = () => {
		const type = visitorAndSpendType.id
		const dayOrNight = visitorAndSpendOptions.day_or_night

		if (type === 'visitor' && dayOrNight === 'day') {
			return (<VisitorDayLegend />)
		}

		if (type === 'visitor' && dayOrNight === 'night') {
			return (<VisitorNightLegend />)
		}

		if (visitorAndSpendType.id === 'spend') {
			return (<SpendLegend />)
		}

		return null
	}

 	return (
		<div style={{
			marginTop: 8,
			marginLeft: 24,
			marginRight: 8,
		}}>
			{renderLegend()}
		</div>
	)
}

function VisitorDayLegend() {
	return (
		<svg viewBox="0 0 485 88" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
			width: '100%',
		}}>
			<g>
				<path d="M69.131 25.4694H0.7188V41.3877H137.922V25.4694Z" fill="#FFFFFF" />
				<path d="M137.922 25.4694H69.7188V41.3877H137.922V25.4694Z" fill="#E2EEF8"/>
				<path d="M207.641 25.4694H137.922V41.3877H207.641V25.4694Z" fill="#B2C9E9"/>
				<path d="M277.359 25.4694H207.641V41.3877H277.359V25.4694Z" fill="#84A6D4"/>
				<path d="M347.078 25.4694H277.359V41.3877H347.078V25.4694Z" fill="#5884B9"/>
				<path d="M415.281 25.4694H347.078V41.3877H415.281V25.4694Z" fill="#326396"/>
				<path d="M485 25.4694H415.281V41.3877H485V25.4694Z" fill="#18446C"/>
				<path d="M69.7188 25.4694V49.3469" stroke="white"/>
				<text id="value-00" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="0" y="64.1014">1</tspan>
				</text>
				<text id="value-01" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="58" y="64.1014">250</tspan>
				</text>
				<path d="M137.922 25.4694V49.3469" stroke="white"/>
				<text id="value-02" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="126.109" y="63.7913">500</tspan>
				</text>
				<path d="M207.641 25.4694V49.3469" stroke="white"/>
				<text id="value-03" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="191.891" y="63.7913">1000</tspan>
				</text>
				<path d="M277.359 25.4694V49.3469" stroke="white"/>
				<text id="value-04" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="261.609" y="63.7913">3000</tspan>
				</text>
				<path d="M347.078 25.4694V49.3469" stroke="white"/>
				<text id="value-05" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="331.328" y="63.7913">5000</tspan>
				</text>
				<path d="M415.281 25.4694V49.3469" stroke="white"/>
				<text id="value-06" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="395.438" y="64.2852">7500+</tspan>
				</text>
				<text id="headline" fill="white" xmlSpace="preserve" style={headlineStyle}>
					<tspan x="0" y="14.2852">Visitor Counts (per hex)</tspan>
				</text>
				<rect x="0.5" y="25.3163" width="484" height="16" stroke="white"/>
			</g>
		</svg>
	)
}

function VisitorNightLegend() {
	return (
		<svg viewBox="0 0 485 88" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
			width: '100%',
		}}>
			<g>
				<path d="M69.131 25.4694H0.7188V41.3877H137.922V25.4694Z" fill="#FFFFFF" />
				<path d="M137.922 25.4694H69.7188V41.3877H137.922V25.4694Z" fill="#E2EEF8"/>
				<path d="M207.641 25.4694H137.922V41.3877H207.641V25.4694Z" fill="#B2C9E9"/>
				<path d="M277.359 25.4694H207.641V41.3877H277.359V25.4694Z" fill="#84A6D4"/>
				<path d="M347.078 25.4694H277.359V41.3877H347.078V25.4694Z" fill="#5884B9"/>
				<path d="M415.281 25.4694H347.078V41.3877H415.281V25.4694Z" fill="#326396"/>
				<path d="M485 25.4694H415.281V41.3877H485V25.4694Z" fill="#18446C"/>
				<path d="M69.7188 25.4694V49.3469" stroke="white"/>
				<text id="value-00" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="0" y="64.1014">1</tspan>
				</text>
				<text id="value-01" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="58" y="64.1014">250</tspan>
				</text>
				<path d="M137.922 25.4694V49.3469" stroke="white"/>
				<text id="value-02" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="126.109" y="63.7913">500</tspan>
				</text>
				<path d="M207.641 25.4694V49.3469" stroke="white"/>
				<text id="value-03" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="191.891" y="63.7913">1000</tspan>
				</text>
				<path d="M277.359 25.4694V49.3469" stroke="white"/>
				<text id="value-04" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="261.609" y="63.7913">3000</tspan>
				</text>
				<path d="M347.078 25.4694V49.3469" stroke="white"/>
				<text id="value-05" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="331.328" y="63.7913">5000</tspan>
				</text>
				<path d="M415.281 25.4694V49.3469" stroke="white"/>
				<text id="value-06" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="395.438" y="64.2852">7500+</tspan>
				</text>
				<text id="headline" fill="white" xmlSpace="preserve" style={headlineStyle}>
					<tspan x="0" y="14.2852">Visitor Counts (per hex)</tspan>
				</text>
				<rect x="0.5" y="25.3163" width="484" height="16" stroke="white"/>
			</g>
		</svg>
	)
}

function SpendLegend() {
	return (
		<svg viewBox="0 0 485 88" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
			width: '100%',
		}}>
			<g>
				<path d="M92.729 25.4692H0.4236V41.3876H192.729V25.4692Z" fill="#FFFFFF"/>
				<path d="M192.729 25.4692H97.4236V41.3876H192.729V25.4692Z" fill="#E2EEF8"/>
				<path d="M290.153 25.4692H192.729V41.3876H290.153V25.4692Z" fill="#93B2DC"/>
				<path d="M387.576 25.4692H290.153V41.3876H387.576V25.4692Z" fill="#4B79AE"/>
				<path d="M485 25.4692H387.576V41.3876H485V25.4692Z" fill="#18446C"/>
				<path d="M97.5825 25.4692V49.3468" stroke="white" />
				<text id="value-01" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="0" y="64.1013">1</tspan>
				</text>
				<text id="value-01" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="90.3733" y="64.1013">50</tspan>
				</text>
				<path d="M192.788 25.4692V49.3468" stroke="white"/>
				<text id="value-02" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="180.975" y="63.791">100</tspan>
				</text>
				<path d="M289.575 25.4692V49.3468" stroke="white"/>
				<text id="value-03" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="277.763" y="63.791">150</tspan>
				</text>
				<path d="M388.303 25.4692V49.3468" stroke="white"/>
				<text id="value-04" fill="white" xmlSpace="preserve" style={baseStyle}>
					<tspan x="372.519" y="63.791">600+</tspan>
				</text>
				<text id="headline" fill="white" xmlSpace="preserve" style={headlineStyle}>
					<tspan x="0" y="14.2852">Spend Index (per hex)</tspan>
				</text>
				<rect x="0.5" y="25.3164" width="484" height="16" stroke="white"/>
			</g>
		</svg>
	)
}